<div class="cmnh-selector-wrap cmn-selector">
  <input
    [type]="type"
    class="cmnh-selector-input cmn-selector__input"
    [id]="inputId"
    [checked]="checked"
    [attr.aria-label]="labelForAssistiveText"
    (change)="onChange($event)"
  />

  <label class="cmnh-selector-label cmn-selector__label" [for]="inputId">
    @if (type === "radio") {
      <span class="cmnh-selector-mark cmn-selector__radio-mark" aria-hidden="true"></span>
    } @else {
      <svg class="cmnh-selector-mark" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M8.6 13.2 5.4 10l1.2-1.2 2 2 4.8-4.8 1.2 1.2z"></path>
      </svg>
    }

    <span class="cmn-selector__content">
      <strong class="cmn-selector__title" [class.cmn-selector__title--featured]="featured">
        {{ label }}
      </strong>

      @if (description) {
        <span class="cmn-selector__description">
          {{ description }}
        </span>
      }
    </span>
  </label>
</div>
